var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-loading",class:_vm.btnClass,attrs:{"disabled":""}},[_c('div',{staticClass:"spinner-border m-2",attrs:{"role":"status"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }